export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_SOS = 'GET_SOS';
